import { useEffect, useState } from 'react';
import { useClient } from 'jsonapi-react';

// Matéria do próximo bloco pendente da trilha ativa (badge "Missão de hoje").
// null = sem trilha ativa, sem pendências ou erro — o chamador esconde o badge.
export default function useNextMission() {
  const client = useClient();
  const [mission, setMission] = useState(null);

  useEffect(() => {
    let mounted = true;
    client
      .fetch('user_learning_paths')
      .then(response => {
        if (!mounted) return;
        const active = (response?.data || [])[0];
        setMission(active?.['next-block-subject'] || null);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, [client]);

  return mission;
}
